module.exports = __webpack_public_path__ + "static/img/sxlc.03a9f67.png";


//////////////////
// WEBPACK FOOTER
// ./static/sxlc.png
// module id = 0uEa
// module chunks = 1